import { render, staticRenderFns } from "./TypeList.vue?vue&type=template&id=59473a99&scoped=true&"
import script from "./TypeList.vue?vue&type=script&lang=js&"
export * from "./TypeList.vue?vue&type=script&lang=js&"
import style0 from "./TypeList.vue?vue&type=style&index=0&id=59473a99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59473a99",
  null
  
)

export default component.exports